import React from "react";
import { Check, UserCheck } from "lucide-react";
import "../../styles/cmyuva.css";

const CmYuvaDocumentsRequired = () => {
  const documentsRequired = [
    "Passport-size photograph",
    "Signature",
    "Aadhaar Card",
    "PAN Card",
    "Age Proof Certificate",
    "Bank Passbook",
    "Educational Qualification – Minimum 8th Pass",
    "Affidavit",
    "Residence Proof or Electricity Bill / Ration Card",
    "Caste Certificate (for reserved category candidates – mandatory)",
    "Aadhaar-linked Mobile Number",
  ];

  return (
    <section className="cmyuva_eligibility_section bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] py-5 position-relative overflow-hidden">
      <div className="container py-4">
        <div className="align-items-center g-5">
          <div className="text-center mb-3" data-aos="fade-up"  data-aos-offset="120">
            <h2 className="cmyuva_section_title m-4">Documents Required</h2>
          </div>
          <div className="row align-items-start">
            {/* LEFT PART */}
          <div className="col-lg-6 align-items-start" data-aos="fade-right">
            {documentsRequired.map((item, idx) =>
              idx > 5 ? null : (
                <div
                  key={idx}
                  className="d-flex align-items-center p-3 m-3 backdrop-blur-md bg-white/[0.03] rounded-3 shadow-sm border border-white/10 hover-lift transition-all"
                >
                  <span className="number_icon">{idx + 1}</span>
                  {/* </div> */}
                  <span className="fw-medium text-white">{item}</span>
                </div>
              )
            )}
          </div>
            {/* RIGHT PART */}
          <div className="col-lg-6 align-items-start" data-aos="fade-left">
            {documentsRequired.map((item, idx) =>
              idx <= 5 ? null : (
                <div
                  key={idx}
                  className="d-flex align-items-center p-3 m-3 backdrop-blur-md bg-white/[0.03] rounded-3 shadow-sm border border-white/10 hover-lift transition-all"
                >
                  <span className="number_icon">{idx + 1}</span>
                  <span className="fw-medium align-items-center text-white">{item}</span>
                </div>
              )
            )}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmYuvaDocumentsRequired;
